import getEnvVar from "../utils/getEnvVar";
import { ServiceConfig } from "../types/serviceConfig";

/**
 * Fetch environment variables with sensible defaults.
 */
const API_HOST_URL = getEnvVar(
	"REACT_APP_API_HOST_URL",
	"http://127.0.0.1:5001",
).trim(); // Trim spaces
const WSS_HOST_URL = getEnvVar(
	"REACT_APP_WSS_HOST_URL",
	"ws://127.0.0.1:7001",
).trim(); // Trim spaces
const API_PREFIX = getEnvVar("REACT_APP_API_PREFIX", "/api/v1").trim(); // Trim spaces
const COUNTRY_API_PREFIX = getEnvVar(
	"REACT_APP_COUNTRY_API_PREFIX",
	"/country",
).trim(); // Trim spaces
const USE_MOCK_API = getEnvVar("REACT_APP_USE_MOCK_API", "1") === "1";

const NEXTCLOUD_BASE_URL = getEnvVar(
	"REACT_APP_NEXTCLOUD_BASE_URL",
	"https://office.belentlik.tm",
).trim();
const NEXTCLOUD_USERNAME = getEnvVar("REACT_APP_NEXTCLOUD_USERNAME", "").trim();
const NEXTCLOUD_PASSWORD = getEnvVar("REACT_APP_NEXTCLOUD_PASSWORD", "").trim();
const NEXTCLOUD_FOLDER_PATH = getEnvVar(
	"REACT_APP_NEXTCLOUD_FOLDER_PATH",
	"/TEX",
).trim();

/**
 * Construct the service configuration object using the defined types.
 */
export const serviceConfig: ServiceConfig = {
	api: {
		hostUrl: API_HOST_URL,
		prefix: API_PREFIX,
		countryPrefix: COUNTRY_API_PREFIX,
		baseUrl: `${API_HOST_URL}${API_PREFIX}`,
		websocketUrl: `${WSS_HOST_URL}${API_PREFIX}`,
		useMock: USE_MOCK_API,
		yandexKey: getEnvVar("REACT_APP_YANDEX_API_KEY", "").trim(),
	},
	nextCloud: {
		baseUrl: NEXTCLOUD_BASE_URL,
		username: NEXTCLOUD_USERNAME,
		password: NEXTCLOUD_PASSWORD,
		folderPath: NEXTCLOUD_FOLDER_PATH,
	},
	routes: {
		contents: getEnvVar("REACT_APP_API_GET_CONTENTS_ROUTE", "/content_type/"),
		login: getEnvVar("REACT_APP_API_LOGIN_ROUTE", "/auth/login/"),
		register: getEnvVar("REACT_APP_API_REGISTER_ROUTE", "/auth/register/"),
		registerRequest: getEnvVar(
			"REACT_APP_API_REGISTER_REQUEST_ROUTE",
			"/auth/register-request/",
		),
		validateOtp: getEnvVar(
			"REACT_APP_API_VALIDATE_OTP_ROUTE",
			"/auth/validate-otp/",
		),
		forgotPassword: getEnvVar(
			"REACT_APP_API_FORGOT_PASSWORD_ROUTE",
			"/auth/password/forgot/",
		),
		updatePassword: getEnvVar(
			"REACT_APP_API_UPDATE_PASSWORD_ROUTE",
			"/auth/password/update/",
		),
		refreshToken: getEnvVar(
			"REACT_APP_API_REFRESH_TOKEN_ROUTE",
			"/auth/refresh-token/",
		),

		otpLoginRequest: getEnvVar(
			"REACT_APP_API_OTP_LOGIN_REQUEST_ROUTE",
			"/auth/otp-login/request/",
		),

		otpLoginValidate: getEnvVar(
			"REACT_APP_API_OTP_LOGIN_VALIDATE_ROUTE",
			"/auth/otp-login/validate/",
		),
		saveNotificationToken: getEnvVar(
			"REACT_APP_API_SAVE_NOTIFICATION_TOKEN_ROUTE",
			"/auth/save-notification-token/",
		),

		company: getEnvVar("REACT_APP_API_COMPANY_ROUTE", "/company"),
		news: getEnvVar("REACT_APP_API_NEWS_ROUTE", "/news/"),
		wiki: getEnvVar("REACT_APP_API_WIKI_ROUTE", "/wiki/"),
		priceQuote: getEnvVar("REACT_APP_API_PRICE_QUOTE_ROUTE", "/price-quote/"),
		newsletterSubscribe: getEnvVar(
			"REACT_APP_API_NEWSLETTER_SUBSCRIBE_ROUTE",
			"/newsletter/subscribe/",
		),
		priceQuoteAnalyze: getEnvVar(
			"REACT_APP_API_PRICE_QUOTE_ANALYZE_ROUTE",
			"/price-quote/analyze",
		),
		claimNew: getEnvVar(
			"REACT_APP_API_PRICE_QUOTE_ANALYZE_ROUTE",
			"/claim/new/",
		),

		uploadImage: getEnvVar(
			"REACT_APP_API_UPLOAD_IMAGE_ROUTE",
			"/media/upload/",
		),
		getImage: getEnvVar("REACT_APP_API_GET_IMAGE_ROUTE", "/uploads"),
	},
	headers: {
		contentType: getEnvVar(
			"REACT_APP_API_CONTENT_TYPE",
			"application/json; charset=utf-8",
		),
		accept: getEnvVar(
			"REACT_APP_API_ACCEPT",
			"application/json; charset=utf-8",
		),
	},
};

export default serviceConfig;
